/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PersonResumeeReprocessGradeBatch202,
  PostApiV1PersonResumeeReprocessGradeBatch400,
  PostApiV1PersonResumeeReprocessGradeBatch401,
  PostApiV1PersonResumeeReprocessGradeBatch500,
  PostApiV1PersonResumeeReprocessGradeBatchMutationRequest,
  PostApiV1PersonResumeeReprocessGradeBatchMutationResponse,
} from "../../types/personResumeeController/PostApiV1PersonResumeeReprocessGradeBatch.ts";
import { reprocessGradePersonOnlyBatchViewModelSchema } from "../reprocessGradePersonOnlyBatchViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1PersonResumeeReprocessGradeBatch202Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeReprocessGradeBatch202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PersonResumeeReprocessGradeBatch400Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeReprocessGradeBatch400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PersonResumeeReprocessGradeBatch401Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeReprocessGradeBatch401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PersonResumeeReprocessGradeBatch500Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeReprocessGradeBatch500>;

export const postApiV1PersonResumeeReprocessGradeBatchMutationRequestSchema =
  z.lazy(
    () => reprocessGradePersonOnlyBatchViewModelSchema,
  ) as unknown as ToZod<PostApiV1PersonResumeeReprocessGradeBatchMutationRequest>;

export const postApiV1PersonResumeeReprocessGradeBatchMutationResponseSchema =
  z.lazy(
    () => postApiV1PersonResumeeReprocessGradeBatch202Schema,
  ) as unknown as ToZod<PostApiV1PersonResumeeReprocessGradeBatchMutationResponse>;
